module.exports = __webpack_public_path__ + "static/media/shannon.810f325b.png";